export default "__VITE_ASSET__81211cb0__"